export enum userRoles {
  ADMIN = 'Administrator',
  INTERNAL = 'User',
  EXTERNAL = 'ExternalUser'
}
